import { motion } from "framer-motion";
import { BookOpenCheck } from "lucide-react";
import { fadeUp } from "./shared";

export function ValuesSection({ values }) {
  return (
    <section id="values" className="bg-turq-900 py-14 text-white">
      <div className="max-w-6xl mx-auto px-5">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-xl bg-coral-600 flex items-center justify-center"><BookOpenCheck className="w-5 h-5" /></div>
          <h2 className="font-head font-black text-2xl">قيمنا — كل فرصة تزرع قيمة</h2>
        </div>
        <p className="text-turq-300 text-sm mb-8">تُربط كل فرصة تطوعية بقيمة رئيسية وقيم مساندة وأثر متوقع، وفق قيم وزارة التعليم الست</p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {values.map((v, i) => (
            <motion.div key={v.key} initial="hidden" whileInView="show" viewport={{ once: true }}
              variants={{ ...fadeUp, show: { ...fadeUp.show, transition: { delay: i * 0.06, duration: 0.5 } } }}
              data-testid={`value-card-${v.key}`}
              className="rounded-2xl bg-white/5 border border-white/10 p-5 hover:bg-white/10 transition-colors">
              <div className="flex items-center justify-between mb-2">
                <div className="font-head font-black text-lg text-coral-300">{v.name}</div>
                <span className="text-[10px] font-bold bg-coral-600 text-white rounded-full px-2.5 py-1">
                  {v.opportunities} فرصة
                </span>
              </div>
              <p className="text-[12.5px] text-white/75 leading-relaxed mb-3">{v.definition}</p>
              <div className="h-1.5 rounded-full bg-white/10 overflow-hidden">
                <div className="h-full rounded-full bg-coral-300 transition-all duration-700" style={{ width: `${v.realization_pct}%` }} />
              </div>
              <div className="text-[10px] text-white/60 mt-1.5">تحقق الأثر {v.realization_pct}% · {v.participants} مشارك · {v.hours} ساعة</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
